const toNum = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

export const buildFunnelFromCounts = (stepDefs) => {
  if (!stepDefs?.length) return [];
  const base = toNum(stepDefs[0]?.count) || 1;
  return stepDefs.map((step, index) => {
    const count = toNum(step.count);
    const prev = index > 0 ? toNum(stepDefs[index - 1]?.count) || 1 : base;
    return {
      step: step.step || step.label,
      count,
      conversion_rate: base > 0 ? Number((count / base).toFixed(4)) : 0,
      dropoff_rate: index === 0 ? 0 : Number((1 - count / prev).toFixed(4)),
    };
  });
};

const isPhoneVerificationStep = (step) => {
  const name = String(step?.step || step?.label || step?.step_name || "").toLowerCase();
  return name.includes("phone verification") || name === "phone_verification";
};

/** Signup funnel excludes broker-only phone verification step. */
export const filterSignupFunnelSteps = (steps) => {
  if (!steps?.length) return [];
  const filtered = steps.filter((s) => !isPhoneVerificationStep(s));
  if (filtered.length === steps.length) return steps;
  return buildFunnelFromCounts(
    filtered.map((s) => ({ step: s.step || s.label, count: s.count }))
  );
};

export const buildSignupFunnelFromAnalytics = (analytics) => {
  if (!analytics) return [];
  const summary = analytics.summary || {};
  const viewByStep = Object.fromEntries(
    (analytics.step_views || []).map((s) => [s.step_name, toNum(s.users || s.views)])
  );

  const steps = [
    { step: "Flow started", count: summary.flow_started_unique || summary.flow_started },
    { step: "Email details", count: viewByStep.email_details },
    { step: "Password", count: viewByStep.password },
    { step: "OTP verification", count: viewByStep.otp },
    { step: "Signup completed", count: summary.completed_unique || summary.completed },
  ].filter((s, i, arr) => s.count > 0 || i === 0 || i === arr.length - 1);

  return filterSignupFunnelSteps(
    buildFunnelFromCounts(steps.length ? steps : [{ step: "Flow started", count: 0 }])
  );
};

export const buildInvestmentFunnelFromSummary = (data) => {
  if (!data) return [];
  const invCategory = (data.events_overview || []).find((c) => c.category === "Investment funnel");
  const eventCount = (name) =>
    invCategory?.events?.find((e) => e.event === name)?.count || 0;

  const started = eventCount("investment_flow_started") || toNum(data?.kpis?.investments?.value);
  const submitted = eventCount("investment_submitted") || toNum(data?.kpis?.investments?.value);

  if (!started && !submitted) return [];

  return buildFunnelFromCounts([
    { step: "Flow started", count: started || submitted },
    { step: "Submitted", count: submitted },
  ]);
};

/** Per-user funnel steps from API `reached` flags (0 or 1 per step). */
export const buildUserFunnelChartSteps = (funnelSteps) => {
  if (!funnelSteps?.length) return [{ step: "No data", count: 0 }];

  const steps = funnelSteps.map((s) => ({
    step: s.step || s.name || s.key || "Step",
    count: s.reached ? 1 : 0,
  }));

  return steps.some((s) => s.count > 0) ? steps : [{ step: "No data", count: 0 }];
};
